import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const featuresModuleService = createApi({
  reducerPath: 'featuresModuleAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/v1'
  }),
  endpoints: build => ({
    postSalesDepartment: build.mutation({
      query: ({ moduleType, body }) => ({
        url: `/order-call/sales-department/${moduleType}`,
        method: 'POST',
        body: body
      }),
      transformResponse: (response) => response,
    })
  }),
})
